import { message } from 'antd';
import { Icon } from '../../icon/icon';

export const openMessageSuccess = ({ content, icon, iconColor, ...props }) => {
  message.open({
    content: (
      <span className="text-title-medium" style={{ fontWeight: 600 }}>
        {content}
      </span>
    ),
    icon: (
      <span
        className="w-24 h-24 flex"
        style={{ color: iconColor ?? '#3ABB2C' }}
      >
        {icon ?? <Icon.ICSuccess />}
      </span>
    ),
    duration: 9,
  });
};
